module.exports = __webpack_public_path__ + "static/media/delete-disabled.789a5639.svg";